import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlataformaService {
  BASEURL: string;
  httpHeaders: HttpHeaders;

  constructor(private http: HttpClient) {
    this.BASEURL = environment.apiUrl;

    this.httpHeaders = new HttpHeaders({
      Authorization: localStorage.getItem('tokenMappe'),
    });
  }

  listaConfiguracoes(): Observable<any> {
    return this.http.get(`${this.BASEURL}/platform`, {
      headers: this.httpHeaders,
    });
  }

  salvaConfiguracoes(body: any): Observable<any> {
    return this.http.post(`${this.BASEURL}/platform`, body, {
      headers: this.httpHeaders,
    });
  }

  uploadImages(image: string): Observable<any> {
    return this.http.post(`${this.BASEURL}/images`, { image }, {
      headers: this.httpHeaders,
    });
  }
}
